import { render, staticRenderFns } from "./edit.page.vue?vue&type=template&id=536d3b6b&"
import script from "./edit.page.vue?vue&type=script&lang=ts&"
export * from "./edit.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports